import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "@/resources/requestInfo";
import { changePasswordRoutes } from "./routes";
import { IChangePasswordPayload } from "./types";

export const fetchChangePassword = createAsyncThunk<string, IChangePasswordPayload>(
  "changePassword/fetchChangePassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(changePasswordRoutes.CHANGE_PASSWORD, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Ошибка при смене пароля"
      );
    }
  }
);
